import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StatsService } from '../../../services/stats.service';
import { InstallationService } from '../../../services/installation.service';
var moment = require('moment'); // require
import { MatTableDataSource, MatTable } from '@angular/material/table';
import 'moment/locale/es'
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexStroke,
  ApexXAxis,
  ApexFill,
  ApexTooltip
} from "ng-apexcharts";
import { MatSort } from '@angular/material/sort';
import { Address } from 'cluster';
import { animate, state, style, transition, trigger } from '@angular/animations';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
};

@Component({
  selector: 'ngx-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class StatisticsComponent implements OnInit {
  @ViewChild('chart', { static: true }) chart: ChartComponent;


  @ViewChild('outerSort', { static: true }) sort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;
  dataSource: MatTableDataSource<any>;


  usersData: any[] = [];
  columnsToDisplay = [
    '#',
    'Nombre', 'Acrónimo',
    '# total requerimientos',
    '# documentos a entregar',
    '# documentos entregados'];
  innerDisplayedColumns = ['#', 'Nombre', 'Periodicidad', 'Etapa'];
  expandedElement: any | null;

  public chartOptions: Partial<ChartOptions>;
  public chartOptionsLegalRequirements: Partial<ChartOptions>;

  stats_legal_requirements_year = '2023';
  loading: boolean = false;
  logbooksStats: any = [];
  logbooksPerYearStats: any = [];
  logbooksCurrentStats: any = [];
  logbookMonth: any = [];
  logbookRegisteredNumber: any = [];
  today= new Date();
  monthReport = Number(moment(this.today).format('MM'));
  yearReport = Number(moment(this.today).format('YYYY'));
  reportNameMonth= moment(this.today).format('MMMM').toUpperCase();
  reportMonth= moment(this.today).format('MM');
  reportYear= moment(this.today).format('YYYY');
  selectDate= new Date();
  stations: any = [];
  stationId = '';
  firstStationId = ''
  legalRequirementsStats: any;
  months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ]

  constructor(
    private statsService: StatsService,
    private installationService: InstallationService,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {
    this.route.params.subscribe(params=>{
      this.firstStationId = params['stationId']
    })
    this.chartOptions = {
      series: [
        {
          name: "Bitácoras Registradas",
          data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
        },
      ],
      chart: {
        type: "bar",
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: [
          "Ene",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dic"
        ]
      },
      fill: {
        opacity: 1
      },
    };
    this.chartOptionsLegalRequirements = {
      series: [
        {
          name: "Bitácoras Registradas",
          data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
        },
      ],
      chart: {
        type: "bar",
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: [
          "Ene",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dic"
        ]
      },
      fill: {
        opacity: 1
      },
    };
  }

  async ngOnInit() {
    moment.locale('es')
    await this.getStationsv2();
    await this.init();
  }

  init () {
    this.getStatsMonthYear()
    this.getLogbooksPerYearStats()
    this.getLogbooksCurrentStats()
    this.getLegalRequirementsStats();
    this.trackMonthlyProgress()
    this.getLegalRequirementsStatistics()
  }

  toggleRow(element: any) {
    this.expandedElement = this.expandedElement === element ? null : element

    this.cd.detectChanges();
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<Address>).sort = this.innerSort.toArray()[index]);
  }

  applyFilter(filterValue: string) {
    this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<Address>).filter = filterValue.trim().toLowerCase());
  }

  async getStationsv2() {
    this.loading = true;
    const [error, result] = await this.installationService.getStationsv2() as any;
    this.loading = false;
    if (error) return console.error(error);
    this.stations = result.data
    this.stationId = this.firstStationId
  }

  async getStatsMonthYear() {
    const [error, data] = await this.statsService.getStationStatsMonthYear(this.stationId, this.monthReport, this.yearReport) as any;
    if (error) return;
    this.logbooksStats = data.data
  }

  getTotal(data) {
    let total = 0;

    data.forEach(el => {
      total = total + el.total
    });

    return total;
  }

  async getLogbooksPerYearStats() {
    const [error, data] = await this.statsService.getStationLogbooksPerYear(this.stationId, this.yearReport) as any;
    if (error) return;
    this.logbooksPerYearStats = data.data
    const totals = this.logbooksPerYearStats.map(el => el.total);
    this.chartOptions.series = [
      {
        name: "Bitácoras Registradas",
        data: totals
      },
    ];
  }

  async getLogbooksCurrentStats() {
    const [error, data] = await this.statsService.getCurrentLogbookStatsMonthYear(this.stationId, this.monthReport, this.yearReport) as any;
    if (error) return;
    this.logbooksCurrentStats = data.data
  }

  async trackMonthlyProgress() {
    this.logbookRegisteredNumber = this.logbooksPerYearStats.map(el => el.total)
    this.logbookMonth = this.logbooksPerYearStats.map(el => el.month);

  }

  async getLegalRequirementsStats() {
    const [error, data] = await this.statsService.getStats(this.stationId);
    if (error) return console.log(error)
    this.legalRequirementsStats = data.data.map(el => {
      return {
        ...el,
        percentage: ((el.total_delivered / el.total_requirements) * 100).toFixed(2)
      }
    });
    const categories = this.legalRequirementsStats.map(el => el.name)
    const percentage = this.legalRequirementsStats.map(el => el.percentage)
    this.chartOptionsLegalRequirements.xaxis = {
      categories
    };
    this.chartOptionsLegalRequirements.series = [
      {
        name: "Porcentage de avance",
        data: percentage
      }
    ];
  }

  async getLegalRequirementsStatistics() {
    const [error, data] = await this.statsService.getLegalRequirementsByStationId(this.stationId, this.stats_legal_requirements_year);
    if (error) return console.error(error);
    const dataFormatted = data.data.map(dependence => {
      return {
        '#': dependence.logo_url,
        'Acrónimo': dependence.acronym,
        'Nombre': dependence.name,
        '# total requerimientos': dependence.total_requirements,
        '# documentos a entregar': dependence.total_documents_required,
        '# documentos entregados': dependence.total_documents_uploaded,
        requirements: new MatTableDataSource(dependence.requirements.map((requirement, index) => {
          return {
            '#': index + 1,
            'Nombre': requirement.name,
            'Periodicidad': requirement.periodicity,
            'Etapa': requirement.stage
          }
        }))
      }
    });

    this.dataSource = new MatTableDataSource(dataFormatted);
    this.dataSource.sort = this.sort;
  }

}
